import React, { memo } from 'react';
import { Table, Box, Space, Flex, Title } from '@mantine/core';
// import classes from "./ProducTable.module.css"

interface ProductTableProps {
    data?: any;
}

const TableComponent: React.FC<ProductTableProps> = ({
    data
}) => {

    const GSM = data ? data[0]?.gsm_size === null ? false : true : '';

    const rows = data?.map((el: any, index: number) => (
        <Table.Tr key={el.id}>
            <Table.Td>{index + 1}</Table.Td>
            <Table.Td>{el?.Vertical?.vertical_name}</Table.Td>
            <Table.Td>{el?.RawMaterial?.material_name}</Table.Td>
            <Table.Td>{el?.RawMaterialSubType?.sub_name}</Table.Td>
            {/* <Table.Td>{el?.water_consumption}</Table.Td> */}
            {!GSM && <Table.Td>{el?.weight}</Table.Td>}
            {!GSM && <Table.Td>{el?.percentage}</Table.Td>}
            {GSM && <>
                {/* <Table.Td>{el?.co2_embodied}</Table.Td> */}
                <Table.Td>{el?.gsm_size}</Table.Td>
                <Table.Td>{el?.sheet_size}</Table.Td>
                <Table.Td>{el?.no_of_product}</Table.Td>
                <Table.Td>{el?.no_of_layer}</Table.Td>
                <Table.Td>{el?.glue_type_co2}</Table.Td>
                <Table.Td>{el?.coverage}</Table.Td>
                <Table.Td>{el?.ink_type_co2}</Table.Td>
            </>
            }
        </Table.Tr>
    ));

    return (
        <div style={{ padding: '10px' }}>
            <Box style={{background:'#40404010'}} p={'sm'}>
                <Flex
                    gap="md"
                    justify="space-between"
                    align="center"
                    direction="row"
                    wrap="wrap"

                    >
                    {/* <Title order={3}>{datalist?.data?.rows[0]?.product_name}</Title> */}
                    <Title order={3}>Component</Title>
                </Flex>
            </Box>
            <Space h={'md'} />
            {/* Table */}
            <Table.ScrollContainer minWidth={1500}>
                <Table striped verticalSpacing="md">
                {/* <Table striped className={classes.customtable}> */}
                    <Table.Thead>
                        <Table.Tr style={{ backgroundColor: '#4040401A' }}>
                            <Table.Th>Component</Table.Th>
                            <Table.Th>Vertical Name</Table.Th>
                            <Table.Th>Raw Material</Table.Th>
                            <Table.Th>Raw Material Sub Type</Table.Th>
                            {/* <Table.Th>Water Consumption</Table.Th> */}
                            {!GSM && <Table.Th>Weight</Table.Th>}
                            {!GSM && <Table.Th>Percentage</Table.Th>}
                            {GSM && <>
                                {/* <Table.Th>CO₂ Embodiment</Table.Th> */}
                                <Table.Th>GSM Size</Table.Th>
                                <Table.Th>Sheet Size</Table.Th>
                                <Table.Th>No. of Product</Table.Th>
                                <Table.Th>No. of Layers</Table.Th>
                                <Table.Th>Glue Type CO₂/cm</Table.Th>
                                <Table.Th>Coverage</Table.Th>
                                <Table.Th>Ink Type CO₂/cm</Table.Th>
                            </>}
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>{rows}</Table.Tbody>
                </Table>
            </Table.ScrollContainer>
            {/* {getlistError && <p style={{ color: 'red' }}>Error: {getlistError.message}</p>} */}

        </div>
    );
}

export default memo(TableComponent);
